import React from "react";
import "../css/ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <div className="contact-wrapper">
        {/* Left Section */}
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>
            Have questions about our leather products or need support?  
            Reach out to us and we’ll respond as soon as possible.
          </p>

          <div className="info-item">
            <span>📍</span>
            <p>Kolkata, West Bengal, India</p>
          </div>

          <div className="info-item">
            <span>📧</span>
            <p>support@goldenhides.in</p>
          </div>

          <div className="info-item">
            <span>📞</span>
            <p>+91 90388 25542</p>
          </div>
        </div>

        {/* Right Section */}
        <div className="contact-form">
          <h3>Send a Message || for bulk orders</h3>

          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input type="text" placeholder="Subject" />
            <textarea placeholder="Your Message" rows="5" required></textarea>

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
